import Table from "@/components/Table";
import Badge from "@/components/Badge";
import AvatarCard from "@/components/AvatarCard";
import NameAvatar from "@/components/NameAvatar";
import { TInspection } from "@/types";
import {useNavigate} from "react-router-dom";
import IconButton from "@/components/buttons/IconButton.tsx";
import {Eye} from "lucide-react";
import {format} from "date-fns";

interface Props {
    inspection: TInspection;
}

export const InspectionListItem = ({ inspection }: Props) => {
    const navigate = useNavigate();

    const handleView = () => {
        if (inspection?.id) {
            navigate(`/inspections/${inspection.id}`, {
                state: { inspection } 
            });
        }
    };

    const getStatusBadgeIntent = (status: string | null) => {
        switch (status) {
            case "PENDING":
                return "warning";
            case "IN_PROGRESS":
                return "primary";
            case "COMPLETED":
                return "success";
            case "CANCELLED":
                return "warning";
            default:
                return "info";
        }
    };

    return (
        <Table.Row>
            <Table.Cell>
                {inspection?.id || "N/A"}
            </Table.Cell>
            <Table.Cell>
                {inspection?.type || "INVESTMENT"}
            </Table.Cell>
            <Table.Cell>
                {inspection?.inspectorNames?.[0] ? (
                    /* The API carries the inspector's name only — there is no photograph
                       on it — so this shows their initials rather than a stock face
                       fetched from a random-avatar service. */
                    <AvatarCard
                        title={inspection.inspectorNames[0]}
                        leading={<NameAvatar name={inspection.inspectorNames[0]} />}
                    />
                ) : (
                    "No Inspector Assigned"
                )}
            </Table.Cell>
            <Table.Cell>
                {inspection?.scheduledDate ?
                    format(new Date(inspection.scheduledDate), 'dd MMM, yyyy') :
                    "Not Scheduled"
                }
            </Table.Cell>
            <Table.Cell>
                <Badge
                    intent={getStatusBadgeIntent(inspection?.status)}
                    text={inspection?.status || "PENDING"}
                />
            </Table.Cell>
            <Table.Cell
                className="flex items-center justify-center gap-3 opacity-80"
            >
                <IconButton
                    intent="secondary"
                    className="border border-secondary-200"
                    onClick={handleView}
                    disabled={!inspection?.id}
                >
                    <Eye className="size-4" />
                </IconButton>
            </Table.Cell>
        </Table.Row>
    );
};